import {theme} from "./Tema";

export const VALORENVIOGRATIS = 350000


export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]

export const ESTADOSOPORTE = [
    {
        nombre: 'Nuevo',
        color: '#39a14b'
    },
    {
        nombre: 'Resuelto',
        color: '#28BFD7'
    },
    {
        nombre: 'En comunicacion',
        color: '#808080'
    },
]

export const DIASRENDIMENTOS = [
    {
        nombre: 'Primeros 5 dias del mes'
    },
    {
        nombre: 'Ultimos 5 dias del mes'
    },

]

export const BANCOSACEPTADOS = [
    {
        nombre: 'Nequi'
    },
    {
        nombre: 'Daviplata'
    },
    {
        nombre: 'Bancolombia'
    }
]


export const TIPOCUENTA = [
    {
        nombre: 'Cuenta Ahorros'
    },
    {
        nombre: 'Cuenta Corriente'
    },
    {
        nombre: 'Billetera Digital'
    },
    {
        nombre: 'Bre-B'
    }
]

export const ESTADOMOVIMIENTOS = [

    {
        nombre: 'Nuevo',
        color: '#39a14b'
    },
    {
        nombre: 'Enviado',
        color: '#39a14b'
    },
    {
        nombre: 'Aceptado',
        color: '#28BFD7'
    },
    {
        nombre: 'Rechazado',
        color: '#dd6e6e'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
]